import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c4775c56"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=c4775c56&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports